<template>
  <div class="confirm-result">
    <div class="confirm-result-container">
      <!-- Area List File Name -->
      <div class="column-left">
        <div class="btn-prev-image" v-if="templateResult.items && templateResult.items.length > 3">
          <img src="@/assets/prev_image.png" alt="" @click="prevImage">
        </div>
        <div class="btn-next-image" v-if="templateResult.items && templateResult.items.length > 3">
          <img src="@/assets/next_image.png" alt="" @click="nextImage">
        </div>
        <!-- List File -->
        <div class="list-file" ref="listFile">
          <div
            class="list-file-name cursor-pointer"
            :class="[ind == index ? 'ocr-button-outline' : '']"
            v-for="(item, ind) in templateResult.items"
            :key="ind"
          >
            <div @click="changeIndex(ind, item)" class="bg-image">
              <div class="file-name truncate">
                {{ ind + 1 + ". " + cutName(item.image_path) }}
              </div>
              <div
                class="w-100 h-40 mt-2 box-file relative"
                :class="
                  item.is_confirmed
                    ? 'bg-box-file-success'
                    : 'bg-box-file-error'
                "
              >
                <img
                  :src="item.image_path"
                  alt=""
                  class="w-full h-40 object-contain ocr-image"
                />
                <img
                  v-if="item.is_confirmed"
                  src="@/assets/check-circle.png"
                  alt=""
                  class="absolute"
                />
                <i
                  v-if="!item.is_confirmed && !item.status"
                  class="el-icon-loading ocr-icon-loading absolute text-3xl"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <div class="column-left-footer">
          <el-button
            type="text"
            class="add-template-button add-template-button-card add-template-custom-button"
            @click="modalAddTemplateBatch = true"
          >
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M19.773 10.4623C19.7812 9.55143 19.1042 8.87441 18.1933 8.88256L11.5139 8.9423L11.5736 2.26283C11.5817 1.352 10.9047 0.67498 9.99389 0.683127C9.08305 0.691274 8.39382 1.38051 8.38567 2.29135L8.32592 8.97082L1.64646 9.03056C0.73562 9.03871 0.0463813 9.72795 0.0382344 10.6388C0.0341606 11.0942 0.258476 11.4717 0.559372 11.7726C0.860269 12.0735 1.23775 12.2978 1.69316 12.2937L8.37263 12.234L8.31289 18.9134C8.30881 19.3689 8.53313 19.7463 8.83403 20.0472C9.13492 20.3481 9.5124 20.5724 9.96782 20.5684C10.8787 20.5602 11.5679 19.871 11.576 18.9601L11.6358 12.2807L18.3153 12.2209C19.0756 12.0623 19.7649 11.3731 19.773 10.4623Z" fill="white"/>
            </svg>
          </el-button>
          <div
            class="ocr-button orc-button-sp"
            name="ocr_result.csv"
          >
            <el-button
              @click="downloadExportXlsxCompress()"
              :disabled="isDisableDownloadCSV"
              class="w-full btn-main rounded-lg"
            >
              まとめてXLSX
            </el-button>
          </div>
        </div>
      </div>
      <!-- Area Image OCR -->
      <div class="img-area relative image-pdf">
        <div class="z-50 flex justify-between items-center" ref="bgImageOcr">
          <div class="zoom-stickygroup-edit-left zoom-button rounded-full">
            <el-button
              @click="zoom(-1)"
              :disabled="zoomLevel < 0.1"
              type="info"
            >
              -
            </el-button>
            <span class="text-white font-bold text-lg">
              {{ `${parseInt((zoomLevel * 10).toFixed() * 10)}%` }}
            </span>
            <el-button @click="zoom(1)" type="info">+</el-button>
          </div>
        </div>
        <div class="drag-drop" id="image-ocr" ref="imageOcr">
          <v-stage ref="stage" :config="drrConfig">
            <v-layer ref="layer">
              <div v-for="(box, index) in boxes" :key="index">
                <v-rect
                  @click="chooseBoxActive(index)"
                  :config="{
                    name: box.name,
                    x: Math.min(box.x, box.x + box.width),
                    y: Math.min(box.y, box.y + box.height),
                    width: Math.abs(box.width),
                    height: Math.abs(box.height),
                    fill: box.active
                      ? 'rgb(177, 215, 182, 0.3)'
                      : 'rgb(165, 197, 222, 0.3)',
                    stroke: box.active
                      ? 'rgb(177, 215, 182)'
                      : 'rgb(165, 197, 222)',
                    strokeWidth: 4,
                    draggable: true,
                    is_box: true,
                    strokeScaleEnabled: false,
                    scaleX: 1,
                    scaleY: 1,
                  }"
                  :class="[box.name]"
                  v-if="box.name"
                />
              </div>
            </v-layer>
          </v-stage>
        </div>
      </div>

      <!-- Result OCR -->
      <div class="overflow-auto bg-white column-right">
        <div class="result-list">
          <div class="px-2 break-all">{{ fileName }}</div>
          <div class="result-list-button">
            <el-button @click="exportXlsx()" :disabled="isDisableDownloadCSVResult" class="ocr-button btn-main">
              この1枚だけXLSX
            </el-button>
          </div>
          <div>
            <el-button type="text" @click="modalDeleteTemplateBatch = true" :disabled="itemsLength <= 1">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.74045 7.67773H4.14832V14.2568H4.74045V7.67773Z" fill="#070304"/>
                <path d="M11.8517 7.67773H11.2595V14.2568H11.8517V7.67773Z" fill="#070304"/>
                <path d="M8.29661 7.67773H7.70447V14.2568H8.29661V7.67773Z" fill="#070304"/>
                <path d="M10.9568 17.0008H5.04427C3.94266 16.9997 2.88651 16.5944 2.10756 15.8737C1.3286 15.1531 0.890461 14.1759 0.889282 13.1568V5.49345C0.889282 5.39047 0.89709 5.2875 0.905994 5.19173L0.928243 4.93945H15.075L15.0962 5.19277C15.104 5.29575 15.1118 5.3915 15.1118 5.49345V13.1568C15.1106 14.1759 14.6724 15.1531 13.8935 15.8737C13.1145 16.5944 12.0584 16.9997 10.9568 17.0008ZM1.48144 5.48727V13.1568C1.48144 14.0307 1.85669 14.8689 2.52464 15.4868C3.1926 16.1048 4.09856 16.452 5.04319 16.452H10.9557C11.9003 16.452 12.8062 16.1048 13.4742 15.4868C14.1422 14.8689 14.5174 14.0307 14.5174 13.1568V5.48727H1.48144Z" fill="#070304"/>
                <path d="M14.8157 4.38877H1.18539C0.871189 4.38822 0.570003 4.2725 0.347826 4.06696C0.125649 3.86141 0.0005884 3.58278 0 3.29209V2.74117C0.0005884 2.45048 0.125649 2.17185 0.347826 1.96631C0.570003 1.76076 0.871189 1.64504 1.18539 1.6445H6.51909V1.37059C6.51938 1.00718 6.67556 0.658715 6.95333 0.40174C7.23109 0.144764 7.60773 0.000272734 8.00054 0C8.39336 0.000272734 8.76999 0.144764 9.04776 0.40174C9.32552 0.658715 9.4817 1.00718 9.482 1.37059V1.6445H14.8157C15.1298 1.64504 15.4309 1.76079 15.6529 1.96637C15.8749 2.17195 15.9997 2.45058 16 2.74117V3.28899C16.0003 3.43315 15.9699 3.57594 15.9105 3.70923C15.8512 3.84251 15.764 3.96367 15.654 4.06579C15.5441 4.16792 15.4134 4.24901 15.2696 4.30442C15.1258 4.35984 14.9715 4.3885 14.8157 4.38877ZM1.18539 2.19645C1.02835 2.19645 0.877725 2.25415 0.766678 2.35689C0.65563 2.45963 0.59324 2.59898 0.59324 2.74427V3.29209C0.59324 3.43748 0.655594 3.57693 0.76661 3.67983C0.877626 3.78273 1.02825 3.84067 1.18539 3.84095H14.8157C14.9729 3.84067 15.1235 3.78273 15.2345 3.67983C15.3455 3.57693 15.4078 3.43748 15.4078 3.29209V2.74117C15.4078 2.66923 15.3925 2.598 15.3628 2.53154C15.333 2.46507 15.2894 2.40468 15.2344 2.35381C15.1794 2.30294 15.1142 2.26259 15.0423 2.23505C14.9705 2.20752 14.8935 2.19335 14.8157 2.19335H8.88876V1.36956C8.88876 1.15107 8.79494 0.941535 8.62795 0.787044C8.46097 0.632553 8.23449 0.545762 7.99833 0.545762C7.76218 0.545762 7.53567 0.632553 7.36868 0.787044C7.20169 0.941535 7.10788 1.15107 7.10788 1.36956V2.19335L1.18539 2.19645Z" fill="#070304"/>
              </svg>
            </el-button>
          </div>
        </div>
        <hr />
        <div class="relative">
          <div class="overflow-auto max-h-right hide-scroll">
            <div
              class="p-3"
              v-for="(item, index) in template.images"
              :key="index"
              @click="activeSpecifiedBoxResult(item)"
              :class="{ 'mt-1': !item.pid, 'bg-active-item': item.active }"
            >
              <div v-if="!item.pid" class="mt-1 mb-1">
                <span>{{ getBoxTitle(item) }}</span>
              </div>
              <div
                v-if="
                  item.pid ||
                    !template.images[index + 1] ||
                    !template.images[index + 1].pid
                "
              >
                <img :src="item.image_path" alt="" />
              </div>
              <div
                class="mt-3 mb-4"
                v-if="
                  item.pid ||
                    !template.images[index + 1] ||
                    !template.images[index + 1].pid
                "
              >
                <el-input autosize type="text" :rows="2" v-model="item.result"></el-input>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ADD TEMPLATE BATCH -->
    <el-dialog
      title="画像の追加"
      :visible.sync="modalAddTemplateBatch"
      :width="'30%'"
      @closed="closeModelAddTemplateBatch"
      class="ocr-dialog"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form>
        <p class="mb-4 text-red-500">{{ errorCreateTemplate }}</p>
        <p class="title-modal-add">
          画像のファイルを選んでください。(jpg, png, pdf)
        </p>
        <div class="flex justify-between items-center flex-wrap mt-4 mb-4">
          <el-button @click="selectFile" class="ocr-button ocr-button-default">
            ファイルを選択
          </el-button>
          <input
            type="file"
            @change="chooseFile"
            ref="selectFile"
            class="hidden"
            multiple
          />
          <div v-if="fileLength">{{ fileLength }} 選択</div>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button  class="ocr-button ocr-button-default" @click="closeModelAddTemplateBatch">キャンセル</el-button>
          <el-button @click="runTemplate" :disabled="disableAdd || upload_files.length === 0" class="btn-main ocr-button">追加</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- DIALOG DELETE BATCH -->
    <el-dialog
      title=""
      :visible.sync="modalDeleteTemplateBatch"
      width="30%"
      class="ocr-dialog"
      :show-close="false"
    >
      <div class="mt-4 mb-4"> 指定している画像を本当に削除したいですか？</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="ocr-button ocr-button-default" @click="modalDeleteTemplateBatch = false">いいえ</el-button>
        <el-button type="danger" class="ocr-button btn-main" @click="submitDeleteBatch">
          はい、削除する
        </el-button>
      </span>
    </el-dialog>

    <!-- DIALOG DELETE BUSINESS CARD -->
    <el-dialog title="" :visible.sync="showModelDeleteBusinessCard" width="30%">
      <span>指定したフィールドを本当に削除しますか？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showModelDeleteBusinessCard = false">
          いいえ
        </el-button>
        <el-button type="danger" @click="deleteFielBusinessCard">
          はい、削除する
        </el-button>
      </span>
    </el-dialog>

    <!-- DIALOG DELETE TEMPLATE CARD -->
    <el-dialog title="" :visible.sync="isShowDeleteTemplateModel" width="30%">
      <span>指定したフィールドを本当に削除しますか？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDeleteTemplateModel = false">
          いいえ
        </el-button>
        <el-button type="danger" @click="deleteFieldTemplateCard">
          はい、削除する
        </el-button>
      </span>
    </el-dialog>
    <!-- DIALOG SHOW NOT FOUND-->
    <el-dialog
        title="" :visible.sync="popupNotFound"
        :width="getDevice === 'desktop' ? '30%' : '95%'"
        :show-close="false"
        class="ocr-dialog" :close-on-press-escape="false"
        :close-on-click-modal="false">
      <span>該当データが存在しません</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="backToList" class="btn-main ocr-button leading-1">
           保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import fixHeightMain from "@/mixins/fixHeightMain.mixin";
import common from "@/mixins/common.mixin";
import {mapActions, mapGetters, mapState} from "vuex";
import _ from "lodash";
import Panzoom from "@panzoom/panzoom";
import { sortItems, getTitle } from "@/utils/template";
import {
  TEMPLATE_INVOICE_IDS,
  MULTIPLE_LINE_TITLES,
} from "@/constants/template";
import { groupItems } from "@/utils/template";
import colection from "@/config/detailBatch";
import { configSquareType } from "@/config/squareType";

export default {
  props: ["id"],
  mixins: [fixHeightMain, common],
  components: {},
  data: function() {
    return {
      modalAddTemplateBatch: false,
      modalDeleteTemplateBatch: false,
      fileLength: null,
      upload_files: [],
      activeBatch: null,
      itemsLength: null,
      colection,
      collection_id: 1,
      events: "",
      fileName: null,
      type: "",
      template: {},
      index: 0,
      imgWidth: 0,
      imgHeight: 0,
      img: {},
      zoomLevel: 1,
      templateResult: {},
      isShowDeleteTemplateModel: false,
      deleteTemplateData: {},
      totalResult: null,
      resultCorrect: 0,
      drrConfig: {
        width: 0,
        height: 0,
      },
      is_instant: false,
      is_assignment: false,
      typingTimer: null,
      isChangeInputAutoSave: false,
      dataImageBusinessCard: {},
      note: null,
      isClickConfirm: false,
      showModelDeleteBusinessCard: false,
      dataDeleteBusinessCard: {},
      intervalId: "",
      isDisableDownloadCSV: false,
      isDisableDownloadCSVResult: false,
      imageConfirm: false,
      disableAdd: false,
      errorCreateTemplate: "",
      popupNotFound: false,
    };
  },
  computed: {
    ...mapState({
      templateActive: (state) => state.template.template,
    }),
    ...mapGetters("device", ['getDevice']),
    boxes: {
      get: function() {
        return this.template.boxes;
      },
      set: function(value) {
        return value;
      },
    },
    images: {
      get: function() {
        return this.template.images;
      },
      set: function(value) {
        return value;
      },
    },
    ...mapState({
      collectionActive: (state) => state.collection.collection,
      items: (state) => state.template.items,
    }),
    isSpecified() {
      return this.collectionActive.id == 1;
    },
    items_data: function() {
      let data = [];
      if (this.template.images) {
        this.template.images.forEach((item, index) => {
          data.push({
            id: "",
            image_path: "",
            status: "",
            correct: false,
          });
          data[index].id = item.id;
          data[index].status = item.status;
          data[index].image_path = item.image_path;
          data[index].title = item.title;
          data[index].result = item.result;
        });
      }
      return data;
    },

    items_data_csv: function() {
      let data = [];
      /* For template has table */
      /* OUTPUT
        ----------------------------------------------
        |   ID   | 商品コード |   商品名   |    Date    |
        ----------------------------------------------
        |    1   |    720   |    P1     | 2021-01-02 |
        ----------------------------------------------
        |        |    721   |    P2     |            |
        ----------------------------------------------
        |        |    722   |    P2     |            |
        ----------------------------------------------
        |    2   |    800   |    P2     | 2021-11-16 |
        ----------------------------------------------
        |        |    801   |    P2     |            |
        ----------------------------------------------
       */
      // Type = 1, always has title
      if (
        this.items &&
        !this.templateActive.is_assignment &&
        TEMPLATE_INVOICE_IDS.indexOf(this.templateActive.id) > -1
      ) {
        this.items.forEach((item) => {
          let maxLines = item.images.reduce((prevMax, currObj) => {
            if (
              MULTIPLE_LINE_TITLES.indexOf(currObj.title) === -1 ||
              !currObj.result
            )
              return prevMax;
            let currMax = currObj.result.split("\n").length;
            return Math.max(prevMax, currMax);
          }, 1);

          let line = null;
          for (let i = 0; i < maxLines; i++) {
            line = {
              id: "",
              image_path: "",
              status: "",
            };

            if (i === 0) {
              line = {
                id: item.id,
                image_path: item.image_path,
                status: item.status,
              };
            }

            item.images.forEach((box) => {
              line[box.title] = i === 0 ? box.result : "";

              if (MULTIPLE_LINE_TITLES.indexOf(box.title) > -1 && box.result) {
                let results = box.result.split("\n");
                line[box.title] =
                  typeof results[i] !== "undefined" ? results[i] : "";
              }
            });
            data.push(line);
          }
        });
        return data;
      }

      // Type = 0, title in image = '', need get it from template boxes
      if (this.items && this.collectionActive.id === 1) {
        let items = groupItems(this.items);
        items.forEach((item) => {
          let maxLines = 1;
          for (let i in item.group) {
            maxLines = Math.max(item.group[i].children.length, maxLines);
          }

          for (let i = 0; i < maxLines; i++) {
            let line = {
              id: "",
              image_path: "",
              status: "",
            };

            if (i === 0) {
              line = {
                id: item.id,
                image_path: item.image_path,
                status: item.status,
              };
            }

            for (let j in item.group) {
              let box = item.group[j];
              let title = getTitle(box.parent, this.templateActive);
              if (!box.children.length) {
                if (i === 0) line[title] = box.parent.result;
                continue;
              }
              let boxChild = box.children[i] || {};
              line[title] = boxChild.result;
              line[title + " image_path"] = boxChild.image_path;
            }
            data.push(line);
          }
        });
        return data;
      }

      // Type = 0, title in image = '', need get it from template boxes
      if (this.items && !this.templateActive.is_assignment) {
        this.items.forEach((item, index) => {
          data.push({
            id: "",
            image_path: "",
            status: "",
          });
          data[index].id = item.id;
          data[index].status = item.status;
          data[index].image_path = item.image_path;
          item.images.forEach((box, boxIndex) => {
            if (!box.title) {
              box.title = this.resultBoxes?.boxes[boxIndex]?.title;
            }
            data[index][box.title] = box.result;
          });
        });
      }
      if (this.items && this.templateActive.is_assignment) {
        this.items.forEach((item, index) => {
          data.push({
            id: "",
            image_path: "",
            status: "",
            result: "",
          });
          data[index].id = item.id;
          data[index].status = item.status;
          data[index].image_path = item.image_path;
          if (this.items[index].score) {
            data[index].result = this.items[index].score;
          } else {
            data[index].result = `0/${this.items.length}`;
          }
          item.images.forEach((box, boxIndex) => {
            if (!box.title) {
              box.title = this.resultBoxes?.boxes[boxIndex]?.title;
            }
            data[index][box.title] = box.result;
          });
        });
      }
      return data;
    },
  },
  watch: {
    template: {
      deep: true,
      handler: function() {
        this.isChange = true;
        this.hasErrorValidate = false;
        this.hasBoxTitleIsEmpty = false;
        this.boxes.map((box) => {
          if (!!this.imgWidth && !!this.imgHeight) {
            if (!box.title && !box.is_delete) {
              this.hasBoxTitleIsEmpty = true;
            }
            box.start_x = parseInt(box.x) / this.imgWidth;
            box.start_y = parseInt(box.y) / this.imgHeight;
            box.end_x = (parseInt(box.x) + parseInt(box.width)) / this.imgWidth;
            box.end_y =
              (parseInt(box.y) + parseInt(box.height)) / this.imgHeight;
            box.active = Boolean(box.active);
            box.is_delete = Boolean(box.is_delete);
          }
        });
        this.hasDuplicateTitle = false;
        let titleArr = this.boxes.map(function(item) {
          return item.title;
        });
        this.hasDuplicateTitle = titleArr.some(function(item, idx) {
          return titleArr.indexOf(item) !== idx;
        });
        if (this.hasBoxTitleIsEmpty || this.hasDuplicateTitle) {
          this.hasErrorValidate = true;
        }
      },
    },
    boxes: {
      deep: true,
      handler: function() {
        this.resultCorrect = 0;
        if (this.template.images?.length) {
          this.boxes.map((box, index) => {
            if (box.ground_truth === this.template.images[index].result) {
              this.resultCorrect += 1;
            }
          });
        }
      },
    },
    images: {
      deep: true,
      handler: function() {
        this.resultCorrect = 0;
        if (this.template.images && this.template.is_assignment) {
          this.template.images.map((image, index) => {
            if (image.result === this.boxes[index].ground_truth) {
              this.resultCorrect += 1;
            }
          });
        }
      },
    },
  },
  methods: {
    ...mapActions("template", [
      "getTemplate",
      "storeTemplateBox",
      "getTemplateResult",
      "reRunTemplateBatch",
      "getExportXlsx",
      "addTemplateBatch",
      "deleteTemplateBatch",
      "addNoteTemplateBatch",
      "exportXlsxCompress"
    ]),
    ...mapActions(["loading"]),

    setPopupNotFound(value) {
      this.popupNotFound = value;
    },
    backToList() {
      this.$router.push({ name: "export_xlsx"})
      this.setPopupNotFound(false)
    },

    async reRunTemplate() {
      this.loading(true);
      const query = this.$route.params;
      const data = {
        id: query.template_id,
        batchId: query.template_batch_id,
      };
      let res = await this.reRunTemplateBatch(data);
      if (res) {
        this.fetchTemplateResult({
          template_id: this.template_id,
          template_batch_id: this.template_batch_id,
        });
      }
      setTimeout(() => {
        this.$notify.success({
          title: "成功",
          message: `再実行の成功`,
        });
        this.loading(false);
      }, 500);
    },

    selectFile: function() {
      this.upload_files = [];
      this.errorCreateTemplate = ""
      this.$refs.selectFile.click();
    },

    chooseFile: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const arr = [...files];
      this.fileLength = arr.length;
      arr.forEach((file) => {
        this.upload_files.push(file);
      });
    },

    async runTemplate() {
      this.disableAdd = true
      var sefl = this;
      let formData = new FormData();
      formData.append("template_batch_id", this.template_batch_id);
      sefl.upload_files.forEach((file) => {
        formData.append("upload_files", file);
      });
      const data = {
        id: this.template_id,
        formData: formData,
      };
      let res = await this.addTemplateBatch(data);
      if (res.success) {
        await this.fetchTemplateResult({
          template_id: this.template_id,
          template_batch_id: this.template_batch_id,
        }, true)

        this.$notify.success({
          title: "成功",
          message: `アップロードされました。`,
        });

        if (this.collection_id === this.colection.bussiness_card) {
          // Listen until batch runner has been finished
          this.syncData({
            sync: () => {
              this.fetchTemplateResult({
                template_id: this.template_id,
                template_batch_id: this.template_batch_id,
              })
            },
            checkIsFinished: () => {
              for (let i in this.templateResult.items) {
                if (!this.templateResult.items[i].images.length) return false;
              }
              return true;
            }
          });
        }
        this.modalAddTemplateBatch = false;
      } else {
          this.errorCreateTemplate = res.data.message ? res.data.message  : res.data;
      }
      this.disableAdd = false
    },

    closeModelAddTemplateBatch() {
      this.$refs.selectFile.value = null;
      this.upload_files = [];
      this.fileLength = null;
      this.errorCreateTemplate = "";
      this.modalAddTemplateBatch = false;
    },

    async submitDeleteBatch() {
      const data = {
        template_id: this.template_id,
        template_batch_id: this.template_batch_id,
        template_batch_item_id: this.activeBatch,
      };
      if (this.itemsLength > 1) {
        let rs = await this.deleteTemplateBatch(data);
        this.isChange = false;
        if (rs.success) {
          window.location.reload();
        }
      }
      this.modalDeleteTemplateBatch = false;
    },

    async exportXlsx(condition = "one") {
      this.isChange = false;
      const query = this.$route.params;
      const data = {
        id: query.template_id,
        batchId: query.template_batch_id,
      };
      let res = await this.getExportXlsx(data);
      const a = document.createElement("a");
      if (condition == "one") {
        let url = res[this.index];
        const a = document.createElement("a");
        a.href = this.getBackendFullUrl(this.removeBackendHost(url));
        a.download = url.split("/").pop();

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        res.forEach((item) => {
          let url = item;
          a.href = this.getBackendFullUrl(this.removeBackendHost(url));
          a.download = url.split("/").pop();
          a.click();
        });
      }
    },
    downloadExportXlsxCompress: async function () {
      this.isChange = false;
      this.loading(true);
      const query = this.$route.params;
      const data = {
        template_id: query.template_id,
        batch_id: query.template_batch_id
      }
      let url = await this.exportXlsxCompress(data);
      let a = document.createElement("a");
      a.setAttribute('href', this.getBackendFullUrl(url));
      a.setAttribute('download', '');
      a.setAttribute('target', '_blank');
      a.click();
      this.loading(false);
    },
    fetchTemplate: async function(id) {
      let res = await this.getTemplate(id);
      if (res) {
        this.collection_id = res.collection_id;
        this.template = _.cloneDeep(res);
        this.template.url =
          process.env.VUE_APP_BACK_END_URL + "/" + this.template.url;
      }
    },
    zoom(level) {
      this.square = false;
      this.type = "mouse-pointer";
      if (level == 0) {
        let zoomWidth = this.$refs.bgImageOcr.offsetWidth / this.imgWidth;
        if (zoomWidth * 10 < 1) {
          zoomWidth = 1;
        }
        let zoomHeight = this.$refs.bgImageOcr.offsetHeight / this.imgHeight;
        if (zoomHeight * 10 < 1) {
          zoomHeight = 1;
        }
        this.zoomLevel = Math.min(zoomWidth, zoomHeight);
      } else {
        this.zoomLevel += level / 10;
      }
      if (!this.panzoom) {
        this.initZoom();
      }
      this.panzoom.setOptions({ cursor: "grabbing" });
      this.panzoom.zoom(this.zoomLevel, { animate: true });
    },
    initZoom() {
      this.square = false;
      this.type = "";
      if (!this.panzoom) {
        this.panzoom = Panzoom(document.getElementById("image-ocr"), {
          maxScale: 5,
          disablePan: false,
          cursor: "grabbing",
          origin: "top left",
          setTransform: (elem, { x, y, scale }) => {
            elem.style.transform = `scale(${scale}) translate(${x}px, ${y}px)`;
          },
          handleStartEvent: () => {},
        });
      }
    },
    chooseBoxActive: function(index) {
      this.template.images.map((box) => (box.active = false));
      this.template.images[index].active = true;

      this.boxes.map((box) => (box.active = false));
      this.boxes[index].active = true;
      this.handelFocus(index);
    },
    handelFocus(index) {
      let input = document.querySelector(".input-" + index);
      if (input && typeof input !== typeof undefined) {
        input.querySelector("input").focus();
      }
      let item = document.querySelector(".card-item-" + index);
      if (item && typeof input !== typeof undefined) {
        item.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    setBoxValue: function(payload) {
      this.template.boxes[payload.index] = payload.box;
    },
    fetchTemplateResult: async function(data, hasNewPhoto = false) {
      let res = await this.getTemplateResult(data);
      if (res && !res.id) {
        this.setPopupNotFound(true);
        return;
      }
      this.note = res.items[0].note;
      this.formatDataCard(res.items[0].images);
      this.isDisableDownloadCSVResult = !res.items[this.index].status;
      this.isDisableDownloadCSV = res.n_processed !== res.n_results;
      if (!this.isDisableDownloadCSV) {
        clearInterval(this.intervalId);
      }
      this.itemsLength = res.items.length || 0;
      if (this.isSpecified) {
        res.items = sortItems(res.items);
      }
      this.$store.commit("template/SET_ITEMS", res.items);
      if (res && this.itemsLength) {
        res.items.map((item) => {
          item.image_path =
            process.env.VUE_APP_BACK_END_URL + "/" + item.image_path;
          item.images.map((image) => {
            image.active = false;
            image.image_path =
              process.env.VUE_APP_BACK_END_URL + "/" + image.image_path;
          });
          item.boxes = this.template.boxes;
        });
        if (hasNewPhoto) {
          this.intervalId = this.setFetchPageInterval();
          res.items.forEach((element) => {
            if (element.status === 0) {
              element.image_path = element.image_path + `?time=${new Date().getTime()}`;
            }
          });
        }
        this.templateResult = _.cloneDeep(res);
        this.fileName =
          `${this.index + 1}.  ` +
          this.cutName(this.templateResult.items[this.index].image_path);
          this.cutName(this.templateResult.items[this.index].image_path)
        this.imageConfirm = this.templateResult.items[this.index].is_confirmed
        this.is_instant = this.template.is_instant;
        this.is_assignment = this.template.is_assignment;
        this.template = this.templateResult.items[this.index];
        this.template.is_instant = this.is_instant;
        this.template.is_assignment = this.is_assignment;
        let imageOcr = document.getElementById("image-ocr");
        if (imageOcr) {
          imageOcr.style.backgroundImage = `url(${this.template.image_path})`;
          imageOcr.style.backgroundRepeat = "no-repeat";
        }
      }
    },
    generateBoxName() {
      return `drr-item-${Date.now()}-${Math.floor(
        100000 + Math.random() * 900000
      )}`;
    },
    cutName(name) {
      let indexLast = name.lastIndexOf("/");
      return name.substr(indexLast + 1);
    },
    changeIndex(id, data) {
      this.isDisableDownloadCSVResult = !data.status;
      this.intervalId = this.setFetchPageInterval();
      this.isClickConfirm = false;
      this.note = data.note;
      this.dataImageBusinessCard = this.formatDataCard(data.images);
      this.activeBatch = data.id;
      this.fileName = id + 1 + ". " + this.cutName(data.image_path);
      this.index = id;
      if (this.templateResult.items) {
        this.template = this.templateResult.items[this.index];
      }
      let imageOcr = document.getElementById("image-ocr");
      if (imageOcr) {
        imageOcr.style.backgroundImage = `url(${this.template.image_path})`;
          imageOcr.style.backgroundRepeat = "no-repeat";
      }
      this.setSelectedResult();
    },
    previous: function() {
      if (this.index > 0) {
        this.index--;
        this.template = this.templateResult.items[this.index];
        let imageOcr = document.getElementById("image-ocr");
        if (imageOcr) {
          imageOcr.style.backgroundImage = `url(${this.template.image_path})`;
          imageOcr.style.backgroundRepeat = "no-repeat";
        }
        this.setSelectedResult();
      }
    },
    next: function() {
      if (this.index < this.templateResult.items.length - 1) {
        this.index++;
        this.template = this.templateResult.items[this.index];
        this.template.is_assignment = this.is_assignment;
        this.template.is_instant = this.is_instant;
        let imageOcr = document.getElementById("image-ocr");
        if (imageOcr) {
          imageOcr.style.backgroundImage = `url(${this.template.image_path})`;
          imageOcr.style.backgroundRepeat = "no-repeat";
        }
        this.setSelectedResult();
      }
    },
    setSelectedResult: function() {
      this.img = new Image();
      this.img.src = this.template.image_path;

      let self = this;
      this.img.onload = function() {
        self.imgWidth = self.img.width;
        self.imgHeight = self.img.height;

        let imageOcr = document.getElementById("image-ocr");
        if (imageOcr) {
          imageOcr.style.width = self.imgWidth + "px";
          imageOcr.style.height = self.imgHeight + "px";
          imageOcr.style.backgroundImage = `url(${self.template.image_path})`;
          imageOcr.style.backgroundRepeat = "no-repeat";
        }

        self.boxes = self.boxes.map((box) => {
          box.x = box.start_x * self.imgWidth;
          box.y = box.start_y * self.imgHeight;
          box.width = box.end_x * self.imgWidth - box.x;
          box.height = box.end_y * self.imgHeight - box.y;
          box.name = self.generateBoxName();
        });
        self.$store.commit("SET_BOXES", self.boxes);

        let dragDrop = document.getElementsByClassName("drag-drop")[0];
        if (dragDrop) {
          dragDrop.style.width = self.imgWidth + "px";
          dragDrop.style.height = self.imgHeight + "px";
        }
        self.initZoom();
        self.zoom(0);

        // Set canvas frames
        self.drrConfig.width = self.imgWidth;
        self.drrConfig.height = self.imgHeight;
        self.$forceUpdate();
      };
    },
    saveResult: async function() {
      this.isChange = false;
      this.$store.commit("template/SET_ITEMS", this.templateResult.items);
      this.$store.commit("template/DATA_QUERY", {
        template_id: this.template_id,
        template_batch_id: this.template_batch_id,
      });
      await this.$store.dispatch("template/confirmResult", {
        template_batch_id: this.template_batch_id,
        template_id: this.template_id,
        items: JSON.stringify(
          JSON.stringify({
            items: this.templateResult.items,
          }).replace(/\\"/g, '"')
        ),
      });
      this.$router.push({
        name: `templates`,
        params: {
          show_result: true,
          n_process: 100,
        },
      });
    },

    clickConfirm() {
      this.isClickConfirm = true;
      this.confirm();
    },

    confirm: async function() {
      this.loading(true);
      this.isChange = false;
      this.templateResult.items[this.index].note = this.note;
      if (this.isClickConfirm) {
        this.templateResult.items[this.index].is_confirmed = !this.templateResult.items[this.index].is_confirmed;
      }
      this.formatPushApi();
      this.$store.commit("template/SET_ITEMS", this.templateResult.items);
      this.$store.commit("template/DATA_QUERY", {
        template_id: this.template_id,
        template_batch_id: this.template_batch_id,
      });
      if (this.collection_id == this.colection.template) {
        this.templateResult.items.forEach((element) => {
          element.images = element.images.filter((item) => "active" in item);
        });
      }
      if (this.collection_id == this.colection.bussiness_card) {
        this.templateResult.items[0].images = this.templateResult.items[0].images.filter(
          (item) => (!item.data && item.id) || (!item.id && item.data)
        );
      }

      let items = _.cloneDeep(this.templateResult.items);

      // Change image_path to relative path
      for (let i in items) {
        for (let j in items[i].images) {
          items[i].images[j].image_path = this.getBackendRelativeUrl(items[i].images[j].image_path);
        }
      }

      let response = await this.$store.dispatch("template/confirmResult", {
        template_batch_id: this.template_batch_id,
        template_id: this.template_id,
        items: JSON.stringify(
          JSON.stringify({
            items: items,
          }).replace(/\\"/g, '"')
        ),
      });
      this.fetchTemplateResult({
        template_id: this.template_id,
        template_batch_id: this.template_batch_id,
      });
      if (response.message == "更新が成功しました" && this.isChangeInputAutoSave) {
        this.$notify.success({
          title: "成功",
          message: `更新の成功`,
        });
      }
      if (response.success && !this.isChangeInputAutoSave) {
        if (this.collection_id == this.colection.bussiness_card) {
          this.$router.push({
            name: "business_card",
          });
        }
        if (this.collection_id == this.colection.template) {
          this.$router.push({
            name: `templates`,
            params: {
              show_result: true,
              n_process: 100,
            },
          });
        }
      }
      this.isChangeInputAutoSave = false;
      this.loading(false);
    },

    // Auto Save When Change Input
    changeInput() {
      this.isChangeInputAutoSave = true;
      this.confirm();
      this.changeInputNote();
    },

    changeInputNote() {
      const data = {
        template_id: this.template_id,
        template_batch_id: this.template_batch_id,
        template_batch_item_id: this.activeBatch,
        note: this.note,
      };
      this.addNoteTemplateBatch(data);
    },

    goToTemplateDetail: function(id) {
      this.$router.push({
        name: "template.edit",
        params: { id: id },
      });
    },
    activeBoxResult(_box) {
      this.dataImageBusinessCard.map(function(el) {
        return (el.active = false);
      });
      _box.active = true;
    },
    activeBoxTemplate(_box, data) {
      let indexActive = 0;
      if (data) {
        var arr = data.filter((item) => !item.pid);
      }
      this.template.images.map((box) => (box.active = false));
      let activeBoxId = _box.pid || _box.id;
      arr.map((item, index) => {
        if (item.id == activeBoxId) {
          indexActive = index;
        }
      });
      this.boxes.map((box) => (box.active = false));
      this.boxes[indexActive].active = true;
      this.template.images.map(function(_box) {
        if (!_box.pid && _box.id === activeBoxId) {
          return (_box.active = true);
        }
        if (_box.pid && _box.pid === activeBoxId) {
          return (_box.active = true);
        }
        return (_box.active = false);
      });
    },
    activeSpecifiedBoxResult(index, _box) {
      this.boxes.map((box) => (box.active = false));
      this.boxes[index].active = true;
      let activeBoxId = _box.pid || _box.id;
      this.template.images.map(function(_box) {
        if (!_box.pid && _box.id === activeBoxId) {
          return (_box.active = true);
        }
        if (_box.pid && _box.pid === activeBoxId) {
          return (_box.active = true);
        }
        return (_box.active = false);
      });
    },
    getBoxTitle(item) {
      return getTitle(item, this.template);
    },

    formatDataCard(data) {
      let dataOr = _.cloneDeep(data);
      let dataCoppy = _.cloneDeep(data);
      if (data) {
        dataOr.forEach((item) => {
          item.data = [];
          item.data.push({
            id: item.id,
            image_path: item.image_path,
            pid: item.pid,
            result: item.result,
            status: item.status,
            template_box_id: item.template_box_id,
            title: item.title,
          });
          dataCoppy.forEach((el) => {
            if (item.id == el.pid) {
              item.data.push(el);
            }
          });
        });
      }
      this.dataImageBusinessCard = dataOr.filter((item) => !item.pid);
      return this.dataImageBusinessCard;
    },

    // Add One Fiel Business Card
    addFielBusinessCard(item, index) {
      const add = {
        active: false,
        image_path: null,
        data: [],
        pid: item.id,
        result: "",
        status: 1,
        template_box_id: null,
        title: "",
      };
      this.dataImageBusinessCard[index].data.push(add);
    },

    // Show Model Delete Business Card
    showModelDeleteFielBusinessCard(item, index, ind) {
      this.showModelDeleteBusinessCard = true;
      this.dataDeleteBusinessCard = {
        item: item,
        index: index,
        ind: ind,
      };
    },

    // Delete One Fiel Business Card
    deleteFielBusinessCard() {
      if (this.dataDeleteBusinessCard.item.id) {
        this.dataImageBusinessCard[this.dataDeleteBusinessCard.ind].data[
          this.dataDeleteBusinessCard.index
        ].is_delete = true;
        this.confirm();
      } else {
        this.dataImageBusinessCard[this.dataDeleteBusinessCard.ind].data.splice(
          this.dataDeleteBusinessCard.index,
          1
        );
      }
      this.showModelDeleteBusinessCard = false;
    },
    addFieldTemplateCard(item) {
      let images = [];
      const templateImages = this.template.images;
      let hasPushNewImage = false;
      for (let i = 0; i < templateImages.length; i++) {
        // Current image is "selected parent" or "child of selected parent"
        // There is no next image or next image is "next parent"
        // Push old image to array
        images.push(templateImages[i]);

        if (hasPushNewImage) continue;

        if (
          (templateImages[i].id === item.id || templateImages[i].pid === item.id) &&
          (!templateImages[i+1] || !templateImages[i+1].pid)
        ) {
          // If there is no children data, clone parent to children
          // Condition: Current image is "selected parent" and next image is not "child of selected parent"
          if (!templateImages[i].pid &&
            (templateImages[i].id === item.id) &&
            (!templateImages[i+1] || templateImages[i+1].pid !== item.id)
          ) {
            images.push({
              active: templateImages[i].active,
              image_path: templateImages[i].image_path,
              pid: templateImages[i].id,
              result: templateImages[i].result,
              status: templateImages[i].status,
              template_box_id: templateImages[i].template_box_id,
              title: templateImages[i].title,
            });
          }

          // Push addition data
          images.push({
            active: true,
            pid: item.pid || item.id,
            result: '',
            status: item.status,
            template_box_id: item.template_box_id,
            title: '',
          });
          hasPushNewImage = true;
        }
      }

      // Set new image list
      this.template.images = images;
    },
    showModelDeleteFieldTemplateCard(item, index) {
      this.isShowDeleteTemplateModel = true;
      this.deleteTemplateData = {
        item: item,
        index: index,
      };
    },
    deleteFieldTemplateCard() {
      if (this.deleteTemplateData.item.id) {
        this.template.images[this.deleteTemplateData.index].is_delete = true;
        this.confirm();
      } else {
        this.template.images.splice(this.deleteTemplateData.index, 1);
      }
      this.isShowDeleteTemplateModel = false;
    },
    isShowTemplateButton (item) {
      let box = _.find(this.template.boxes, { id: item.template_box_id });
      if (box && [configSquareType.tableRow, configSquareType.tableCol].indexOf(box.box_type) > -1) {
        return true;
      }
      return false;
    },
    formatPushApi() {
      this.dataImageBusinessCard.forEach((element) => {
        element.data.forEach((el) => {
          this.templateResult.items[this.index].images.push(el);
        });
      });
    },

    quantityDelete(data) {
      const total = data.length;
      var del = 0;
      data.forEach((el) => {
        if (el.is_delete) {
          del += 1;
        }
      });
      if (total - del > 1) return false;
      return true;
    },

    // Hide 4 fiel bussiness card
    hideBtnCard(title) {
      const arr = ["氏名", "氏名ロマジ", "組織・団体", "組織・団体ロマジ"];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].match(title)) return false;
      }
      return true;
    },

    // set time auto fetch template list, fetch batch list
    setFetchPageInterval(second = 10000) {
      clearInterval(this.intervalId);
      return setInterval(() => {
        this.fetchTemplateResult({
          template_id: this.template_id,
          template_batch_id: this.template_batch_id,
        });
      }, second);
    },
    prevImage() {
      const leftPos =  this.$refs.listFile.scrollLeft
      this.$refs.listFile.scrollLeft = leftPos - (window.innerWidth / 3 + 2)
    },
    nextImage() {
      const leftPos =  this.$refs.listFile.scrollLeft
      this.$refs.listFile.scrollLeft = leftPos + (window.innerWidth / 3 + 2)
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   let self = this;
  //   if (self.isChange) {
  //     this.$confirm('変更した内容を全て保存しますか？', '', {
  //       confirmButtonText: '保存',
  //       cancelButtonText: '保存しないで完了',
  //       type: 'warning',
  //       distinguishCancelAndClose: true,
  //       loading: false
  //     }).then(() => {
  //       next(false);
  //     }).catch(() => {
  //       self.isChange = false;
  //       next();
  //     })
  //     // const answer = window.confirm(
  //     //   "変更を保存しましたか？ 保存していない変更はすべて失われるのでご注意ください。"
  //     // );
  //     // if (answer) {
  //     //   self.isChange = false;
  //     //   next();
  //     // } else {
  //     //   next(false);
  //     // }
  //   } else {
  //     self.isChange = false;
  //     next();
  //   }
  // },
  mounted: function() {
    self.isChange = false;
  },
  created: async function() {
    this.loading(true);
    let self = this;
    window.onbeforeunload = function() {
      if (self.isChange) {
        return "changes won't be saved when leaving?";
      }
      self.isChange = false;
    };
    let params = self.$route.params;
    this.template_id = params.template_id;
    this.template_batch_id = params.template_batch_id;
    await self.fetchTemplate(this.template_id);
    await self.fetchTemplateResult({
      template_id: this.template_id,
      template_batch_id: this.template_batch_id,
    });
    this.index = 0;
    this.setSelectedResult();
    this.loading(false);
    this.totalResult = this.template.images.length;
    this.intervalId = this.setFetchPageInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
};
</script>

<style scoped>
@import "style/export_result.css";
</style>
